import { useContext } from 'react';
import { ProvideLangContext } from "context/LangProvider";
function useLang() {
    return useContext(ProvideLangContext);
}
export default useLang;
